import React, { Component } from "react"
import { Link } from "react-router-dom"
import {
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Row,
    Table,
    UncontrolledDropdown,
    UncontrolledTooltip,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"

class CharityReturns extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Charity" breadcrumbItem="Returns" />

                        <Row>
                            <Col lg="12">
                                <div className="">
                                    <div className="table-responsive">
                                        <Table className="project-list-table table-nowrap align-middle table-borderless">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: "100px" }}>
                                                        #
                                                    </th>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        1
                                                    </td>
                                                    <td>
                                                        DPD
                                                    </td>
                                                    <td>
                                                        <span className="bg-success badge badge-success">
                                                            Active
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <UncontrolledDropdown>
                                                            <DropdownToggle
                                                                href="#"
                                                                className="card-drop"
                                                                tag="i"
                                                            >
                                                                <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                            </DropdownToggle>
                                                            <DropdownMenu end>
                                                                <DropdownItem href="#">Deactive</DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        1
                                                    </td>
                                                    <td>
                                                        Royal Mail
                                                    </td>
                                                    <td>
                                                        <span className="bg-success badge badge-success">
                                                            Active
                                                        </span>
                                                    </td>

                                                    <td>
                                                        <UncontrolledDropdown>
                                                            <DropdownToggle
                                                                href="#"
                                                                className="card-drop"
                                                                tag="i"
                                                            >
                                                                <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                            </DropdownToggle>
                                                            <DropdownMenu end>
                                                                <DropdownItem href="#">Deactive</DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}

export default CharityReturns
